module.exports = __webpack_public_path__ + "static/media/Take Ownership@4x.1f2fc55c.png";